module.exports = __webpack_public_path__ + "media/assets/images/marker-observer-d3615137030c8affa3236c0e6d59511c.svg";